import type { ComponentType } from 'react'
import Privacy20260831 from './2026-08-31'

export interface PrivacyVersion {
  /** ISO date this version shipped, also used as its file name. */
  date: string
  /** Serbian display form of `date`, shown in the "Datum stupanja na snagu" box. */
  effectiveDateLabel: string
  Content: ComponentType
}

// A content change adds a new entry (and a new dated file) here — never edit
// a shipped entry's file in place. Keeps every version a past visitor saw
// reconstructable instead of silently rewritten. List oldest first.
export const PRIVACY_VERSIONS: PrivacyVersion[] = [
  { date: '2026-08-31', effectiveDateLabel: '31. avgust 2026.', Content: Privacy20260831 },
]

export const LATEST_PRIVACY_VERSION = PRIVACY_VERSIONS[PRIVACY_VERSIONS.length - 1]
